import { OauthAEMConfig } from './config.interfaces';
import { Errors, PingFederateError } from './errors.interfaces';
import {
  AuthorizeResponse,
  ILoginUserNamePasswordInput
} from './oauth.interfaces';

export interface LoginAuthWithCredentialsParams {
  flowId?: string;
  userNamePasswordFields?: ILoginUserNamePasswordInput;
  oauthConfig?: OauthAEMConfig;
  lastNameFormControlValue?: string;
  authId?: string;
  fingerPrint?: string;
  encryptedToken?: string;
}

export interface PostWithCredentials {
  fingerprint?: string;
  username?: string;
  password?: string;
  rememberUser?: boolean;
  continue?: boolean;
  encryptedToken?: string;
  thisIsMyDevice?: boolean;
}

export interface LoginAuthWithCredentials {
  authorizeResponse?: AuthorizeResponse;
  id?: string;
  pluginTypeId?: string;
  status?: string;
  error?: PingFederateError;
  encryptedToken?: string;
  fingerprint?: string;
  errors?: Errors[];
  code?: string;
  error_description?: string;
  resumeUrl?: string;
  showRememberMyUsername?: boolean;
  showThisIsMyDevice?: boolean;
  thisIsMyDeviceSelected?: boolean;
  showCaptcha?: boolean;
  rememberMyUsernameSelected?: boolean;
  message?: string;
}

export interface LoginAuthWithCredentialsReturnObj {
  loginAuthWithCredentials: LoginAuthWithCredentials;
  userNamePass: boolean;
  errorId?: string;
  accountLocked?: boolean;
}

export interface LoginAuthBeforeCredential {
  authorizeResponse?: AuthorizeResponse;
  id: string;
  pluginTypeId?: string;
  status?: string;
  error?: PingFederateError;
  encryptedToken?: string;
  fingerprint?: string;
  errors?: Errors[];
  code?: string;
  error_description?: string;
  resumeUrl?: string;
  showRememberMyUsername?: boolean;
  showThisIsMyDevice?: boolean;
  thisIsMyDeviceSelected?: boolean;
  showCaptcha?: boolean;
  rememberMyUsernameSelected?: boolean;
}

export interface LoginAlternativeAuthentication {
  authenticationSource: string;
}

export interface LoginUserIdentifier {
  identifier: string;
}
